import React from "react";
import { Link } from "gatsby";
// import icon1 from "../../../assets/images/services/service-icon1.png";
import icon1 from "../../assets/images/services/service-icon1.png";
import icon2 from "../../assets/images/services/service-icon2.png";
import icon3 from "../../assets/images/services/service-icon3.png";
import { GraphQLClient, gql } from "graphql-request";
import shape3 from "../../assets/images/services/service-shape3.png";
import { REQUEST_URL } from "../RequestUrl";
import { fontsName } from "../../assets/fonts/fontsName";
import { Button } from "@material-ui/core";
import FeatureModal from "./FeatureModal";
import FeatureCard from "./FeatureCard";

const ALL_FACILITIES = gql`
  query getAllWebsiteFacilitiesByRange($length: String, $page: String) {
    getAllWebsiteFacilitiesByRange(length: $length, page: $page) {
      _id
      title
      description
      pictureLink
    }
  }
`;

const FeaturedServices = () => {
  const [facilitiesList, setFacilitiesList] = React.useState([]);
  const [facilitiesLength, setFacilitiesLength] = React.useState(6);
  const [facilitiesPage, setFacilitiesPage] = React.useState(1);

  const client = new GraphQLClient(REQUEST_URL);
  let temp = [];
  React.useEffect(() => {
    // request(REQUEST_URL, ALL_FACILITIES).then((data) => {
    //   console.log("FACILITIES:", data);
    //   setFacilitiesList(data.getAllWebsiteFacilities);
    // });
    temp = [...facilitiesList];
    let variables = {
      length: facilitiesLength.toString(),
      page: facilitiesPage.toString(),
    };
    client.request(ALL_FACILITIES, variables).then((data) => {
      // temp.push(data.getAllWebsiteFacilitiesByRange);
      if (
        data.getAllWebsiteFacilitiesByRange !== null &&
        data.getAllWebsiteFacilitiesByRange.length > 0
      ) {
        for (let i = 0; i < data.getAllWebsiteFacilitiesByRange.length; i++) {
          setFacilitiesList((p) => [
            ...p,
            data.getAllWebsiteFacilitiesByRange[i],
          ]);
        }
      }
    });
  }, [facilitiesPage]);

  const handleLoadMore = () => {
    setFacilitiesPage((prev) => prev + 1);
  };

  return (
    <div className="featured-services-area pt-100 pb-70">
      <div className="container">
        <div className="row" dir="rtl">
          {facilitiesList && facilitiesList.length > 0
            ? facilitiesList.map((fact, index) => (
                <FeatureCard fact={fact} key={index} />
              ))
            : ""}

          {/* <div className="col-lg-4 col-md-6 col-sm-6">
            <div className="single-featured-services-item">
              <div className="icon">
                <img src={icon2} alt="features" />
              </div>

              <h3>
                <Link to="/service-details">In-person</Link>
              </h3>

              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore.
              </p>

              <Link to="/service-details" className="default-btn">
                <i className="flaticon-right"></i>
                Read More <span></span>
              </Link>

              <div className="shape">
                <img src={shape3} alt="features" />
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-md-3 offset-sm-3">
            <div className="single-featured-services-item">
              <div className="icon">
                <img src={icon3} alt="features" />
              </div>

              <h3>
                <Link to="/service-details">Business</Link>
              </h3>

              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore.
              </p>

              <Link to="/service-details" className="default-btn">
                <i className="flaticon-right"></i>
                Read More <span></span>
              </Link>

              <div className="shape">
                <img src={shape3} alt="features" />
              </div>
            </div>
          </div> */}
        </div>
        <div style={{ width: "100%", textAlign: "center", marginTop: "12px" }}>
          <Button
            variant="outlined"
            color="primary"
            style={{
              padding: "3px 30px",
              borderRadius: "20px",
              fontSize: "16px",
              fontFamily: fontsName.PersianRoyaBold,
            }}
            onClick={handleLoadMore}
          >
            نمایش بیشتر
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FeaturedServices;
